<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <!-- Loading from page -->
    <full-loading v-if="loadingList"/>

    <div class="page-wrapper-row full-height">
      <div class="page-wrapper-middle">
        <div class="page-container">
          <div class="page-content-wrapper">
            <!-- Page Head -->
            <div class="page-head">
              <div class="container padding-bottom-12">
                <!-- Title -->
                <div class="col-md-3 padding-null">
                  <div class="page-title offset-top-4">
                    <h1>Solicitações</h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="page-content">
              <div class="container offset-top-20">
                <!-- Breadcrumb -->
                <ul class="page-breadcrumb breadcrumb breadcrumb-crud">
                  <li>
                    <a href="/dashboard">Dashboard</a>
                    <i class="fa fa-circle"></i>
                  </li>
                  <li>
                    <span class="breadcrumb-active">Solicitações</span>
                  </li>
                </ul>

                <!-- Table -->
                <div v-if="!loadingList && dataSolicitation.length" class="portlet light">
                  <div class="portlet-title">
                    <div class="caption">
                      <span
                        class="caption-subject font-blue bold uppercase">Quantidade total de solicitações ({{ dataSolicitation.length }})</span>
                    </div>
                  </div>

                  <div class="portlet-body contate-table offset-top-20">
                    <div class="table-scrollable table-scrollable-borderless">
                      <table class="table table-hover table-light table-icon">
                        <thead>
                        <tr>
                          <th> NOME</th>
                          <th> EMAIL</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="a in dataSolicitation">
                          <td>{{ a.name }}</td>
                          <td>{{ a.email }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  GET_SOLICITATION
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "solicitation",
  components: {
    topMenu,
    fullLoading
  },
  data() {
    return {
      loadingList: true,
      dataSolicitation: ''
    }
  },
  methods: {
    getAccess() {
      this.loadingList = true;

      REQUEST_SERVICE.get(GET_SOLICITATION + "?t=kkkk").then((response) => {
        UTIL_SERVICE.console("RESULT GET_SOLICITATION:", response.data);
        this.dataSolicitation = response.data;
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.getAccess();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/solicitation/solicitation.vue